import { formatResponse } from "npm-solvitize/utils/Common";
import axios from "axios";
import { localStorageName } from "./constants";
import noImageIcon from "../assets/images/no_image.jpg";
import { protocol, url } from "./config";

export const getDataFromCookie = (key) => {
  try {
    // return JSON.parse(Cookies.get(key) || "{}");

    return JSON.parse(localStorage.getItem(key) || "{}");
  } catch (error) {
    console.error("Failed to parse cookie data", error);
    return {};
  }
};

export const apiRequest = async (
  url,
  method = "GET",
  data = {},
  headers = {}
) => {
  let cookies_data = getDataFromCookie(localStorageName);
  // console.log("Cookies data in utils", cookies_data)
  let token = cookies_data.token || "";
  // console.log("Toke n in utils", token)
  let formatted_response = {};

  let data_to_backend = {};

  // add data to backend if data with key having value
  for (const key in data) {
    if (data[key] !== undefined && data[key] !== null && data[key] !== "") {
      data_to_backend[key] = data[key];
    }
  }

  try {
    const options = {
      method,
      url,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
        ...headers,
      },
      ...(method === "GET" || method === "DELETE"
        ? { params: data_to_backend }
        : { data: data_to_backend }),
    };

    console.log("API Calling ", options);

    // Use axios for API requests
    const response = await axios(options);

    // Analyze and format the response

    formatted_response = formatResponse(response, true);
  } catch (error) {
    // Handle errors and format them
    formatted_response = formatResponse(error.response, false);
  }
  if (formatted_response.status_code == 401) {
    console.log("++++++++++++++++ Session expired ++++++++++++++++++");
    unsetDataOnCookie(localStorageName);
    alert("Your session has expired, please login again");
    window.location.replace("/sign-in");
  }

  return formatted_response;
};

export const unsetDataOnCookie = (storageName) => {
  // Cookies.remove(storageName);
  localStorage.removeItem(storageName);
};

export const addDomainInImage = (image) => {
  // console.log("addDomainInImage ",image)
  let formattedImage = "";

  if (image instanceof Blob) {
    console.log("Blob image ", image);
    // return
    return URL.createObjectURL(image);
  }

  if (image == "" || image == null) {
    let noimage = noImageIcon;
    // console.log("formatted Image ",)
    formattedImage = noimage;
    return formattedImage;
  }
  if (typeof image === "string") {
    if (image === "") {
      let noimage = noImageIcon;
      // console.log("formatted Image ",)
      formattedImage = noimage;
    } else {
      let img = image.includes("http");
      if (img) {
        formattedImage = image.replace("http://", protocol);
      } else {
        formattedImage = url + image;
      }
    }
    // console.log("formatted Image ", formattedImage)
    return formattedImage;
  } else {
    if (image == "") {
      let noimage = noImageIcon;
      // console.log("formatted Image ",)
      formattedImage = noimage;
      return formattedImage;
    }
    // console.log("Cannot format type ",typeof(image))
  }
};

export const getFormattedResponse = (response) => {
  // console.log("Get Formatted Responseeeee", response);
  const contest = response.results[0];
  const eligibleContest = response.extras?.eligible_contest || [];
  const today = new Date();
  const endDate = new Date(contest.context_end_date);
  const eligibility = eligibleContest[0];

  if (
    // 1. If eligible_contest length is zero
    !response ||
    !response.extras ||
    response.extras.eligible_contest.length === 0
  ) {
    return { showContest: false };
  } else if (endDate < today) {
    // 2. If context_end_date is outdated
    return { showContest: false };
  } else if (!eligibility.is_eligible) {
    // 3. If is_eligible = false
    return {
      showContest: false,
      eligible: false,
      reason: eligibility.reason || "Not eligible",
    };
  } else if (eligibility.min_purchase_amount === 0) {
    // 4. If min_purchase_amount == 0
    return {
      showContest: false,
      reason:
        "There is no order limit for current contest have a happy purchase",
    };
  } else {
    return {
      showContest: true,
      eligible: true,
      minimumPurchaseAmount: eligibility.min_purchase_amount,
      totalPurchasesInMonth: eligibility.total_purchases_in_month,
      contest: {
        id: contest.id,
        name: contest.name,
        prize: contest.prize,
        startDate: contest.context_start_date,
        endDate: contest.context_end_date,
      },
    };
  }
};

export const rankClassification = (rank) => {
  if (rank >= 1 && rank <= 3) {
    return { className: "Rank ", rank: rank };
  } else if (rank >= 4 && rank <= 10) {
    return { className: "Class", rank: 2 };
  } else if (rank >= 11 && rank <= 25) {
    return { className: "Class", rank: 3 };
  } else if (rank > 25) {
    return { className: "Class", rank: 4 };
  } else {
    return { className: "Unranked", rank: "N/A" };
  }
};
